// Types
interface DeliveriesResponse {
  result?: {
    orderForm?: {
      deliveryOptions?: {
        ukAvailable?: boolean;
      };
    };
  };
}

interface CollectionBatchResponse {
  result?: {
    orderForm?: {
      collection: {
        available?: boolean;
        extendedNetworkAvailable?: boolean;
      };
    };
  };
}

export function patchDeliveryOptions(
  deliveriesResponse: DeliveriesResponse,
  collectionBatchResponse: CollectionBatchResponse,
) {
  // patch collection batch availability into existing deliveryOptions object.
  // When apo_enabled is made permanent, deliveryOptions from deliveries call can be ignored
  // and all the isCollectionAvailable stuff can be keyed directly off the collection batch response instead
  const {
    available: clickCollectAvailable = false,
    extendedNetworkAvailable: collectPlusAvailable = false,
  } = collectionBatchResponse?.result?.orderForm?.collection ?? {};

  return {
    ...deliveriesResponse,
    result: {
      ...deliveriesResponse?.result,
      orderForm: {
        ...deliveriesResponse?.result?.orderForm,
        deliveryOptions: {
          // in APO world, deliveries response only contains ukAvailable which isn't really needed
          // as delivery is always available. We'll preserve it here anyway for the sake of neatness
          ...deliveriesResponse?.result?.orderForm?.deliveryOptions,
          clickCollectAvailable,
          collectPlusAvailable,
        },
      },
    },
  };
}
